/*
 * @Author: Merlin
 * @Date: 2024-01-30 10:46:04
 * @LastEditors: Merlin
 * @LastEditTime: 2024-01-31 13:53:33
 * @Description: 
 */
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';   
interface BetForm {
    card: number; // 首次提交不需要此键
    amount: number; // 首次提交不需要此键
    currency: string,
}

export const useHiloSocket = (rootPath = 'games') => {
    const sApi = `${rootPath}.hilo.bet`;
    const oJoin = {type: 0, ac: 0};
    const oSkip = {type: 1, ac: 3};
    const oHigh = {type: 2, ac: 1}; // ac：1涨2跌
    const oLow = {type: 2, ac: 2};
    const oStop = {type: 3, ac: 0};
    // ↑ 置于顶部集中管理，防止分散后不便阅读 -----------------
    // ↓ 参加游戏
    const EMIT_HILO_BET = async (data: BetForm) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        const res = await asyncEmit(sApi, {
            ...oJoin, frontID: Date.now(),
            ...data,
        });
        return res;
    };
    // ↓ 跳过（换一张牌）
    const EMIT_HILO_SKIP = async () => {
        const res = await asyncEmit(sApi, {
            ...oSkip, frontID: Date.now(),
        });
        return res;
    };
    // ↓ 押高
    const EMIT_HILO_BET_HIGH = async () => {
        const res = await asyncEmit(sApi, {
            ...oHigh, frontID: Date.now(),
        });
        return res;
    };
    // ↓ 押低
    const EMIT_HILO_BET_LOW = async () => {
        const res = await asyncEmit(sApi, {
            ...oLow, frontID: Date.now(),
        });
        return res;
    };
    // ↓ 提现
    const EMIT_HILO_CHESHOUT = async () => {
        const res = await asyncEmit(sApi, {
            ...oStop, frontID: Date.now(),
        });
        return res;
    };
    return {
        EMIT_HILO_BET,
        EMIT_HILO_SKIP,
        EMIT_HILO_BET_HIGH,
        EMIT_HILO_BET_LOW,
        EMIT_HILO_CHESHOUT,
    };
};

